import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import clsx from 'clsx';
import {
  megaMenuMetaobjects,
  getMegaMenusBannerMetaobjects,
} from '../utils/storefront/queries';
import Storefront from '../utils/storefront';
import {
  formatMegaMenus,
  formatMegaMenusBanners,
} from '../utils/storefront/format-resource';
import { getBannerMedia } from './utils';

const SubMenuItems = ({ menu, isVoyagesLayout }) => {
  const neededMenus = menu.map((m, index) => ({
    title: m.title,
    url: m.url,
    index,
  }));
  const neededMenusBanners = menu.filter((m) => m.title.includes('#banner'));
  const storefront = new Storefront();
  const [megaMenus, setMegaMenus] = useState(null);
  const [megaMenusBanners, setMegaMenusBanners] = useState(null);
  const [columnCount, setColumnCount] = useState(0);
  useEffect(() => {
    const getMegaMenus = async () => {
      try {
        const response = await storefront.request({
          query: megaMenuMetaobjects,
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenus = formatMegaMenus(response, neededMenus);

        setMegaMenus(formattedMegaMenus);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    const getMegaMenusBanners = async () => {
      try {
        const response = await storefront.request({
          query: getMegaMenusBannerMetaobjects(isVoyagesLayout ? 'mega_menu_v_banners' : 'mega_menu_banners'),
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenusBanners = formatMegaMenusBanners(
          response,
          neededMenusBanners,
        );

        setMegaMenusBanners(formattedMegaMenusBanners);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    getMegaMenus();
    getMegaMenusBanners();
  }, [menu]);

  useEffect(() => {
    if (megaMenus && megaMenusBanners) {
      setColumnCount(megaMenus.length);
    }
  }, [megaMenus, megaMenusBanners]);

  const BANNER_TITLE_CLASS = "font-13 text-black block w-fit mt-2.5 mx-auto"
  const V_BANNER_TEXT_CLASSES = 'font-sackers whitespace-nowrap text-[14px] font-light leading-[20px] tracking-[1.4px]'
  const V_BANNER_LINK_CLASS = 'absolute bottom-5 transform -translate-x-1/2 uppercase before:hidden before:content-[]'
  const V_BANNER_P_CLASS = 'absolute w-full bottom-5 uppercase'

  const bannerImageClass = () => {
    if (isVoyagesLayout) {
      return 'w-full h-full relative';
    }
    return columnCount > 5 ? 'max-w-[200px]' : 'max-w-[327px]';
  }

  const getBannerTitleColorClass = (color) => color ? `text-${color}` : 'text-white';

  return (
    <>
      <div
        className={`flex-auto flex items-start justify-start ${
          isVoyagesLayout ? 'w-1/2 p-10' : 'gap-8'
        }`}
      >
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => (
            <div
              key={menuList.handle}
              className="flex-[0_1_200px] [&_a]:font-13"
              style={{ order: menuList.index }}
            >
              <p
                className={clsx(
                  'font-13-bold mb-2.5',
                  isVoyagesLayout ? 'text-neutral' : 'text-black',
                )}
              >
                {menuList.handle}
              </p>
              <ul>
                {menuList.links.length > 0 &&
                  menuList.links.map((link) => (
                    <li key={link.label} className="mb-2">
                      <a href={link.url}>{link.label}</a>
                    </li>
                  ))}
                {menuList.url && (
                  <li className="mb-2">
                    <a href={menuList.url} className="underline">
                      {window.TMW?.Strings?.header?.shopAll}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          ))}
      </div>
      <div
        className={`flex items-start justify-end ${
          isVoyagesLayout ? 'w-1/2 gap-0' : 'gap-5'
        }`}
      >
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div
              key={banner.title}
              className={clsx('min-w-[200px] text-center', bannerImageClass())}
            >
              {banner.url && (
                <a
                  href={banner.url}
                  className={clsx(
                    'block link-unstyled',
                    isVoyagesLayout && 'relative h-full',
                  )}
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  {getBannerMedia({
                    ...banner,
                    isVoyages: isVoyagesLayout,
                    isDesktop: true,
                  })}
                </a>
              )}
              {!banner.url &&
                getBannerMedia({
                  ...banner,
                  isVoyages: isVoyagesLayout,
                  isDesktop: true,
                })}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className={clsx(
                    'underline',
                    isVoyagesLayout
                      ? `${V_BANNER_TEXT_CLASSES}
                         ${V_BANNER_LINK_CLASS}
                         ${getBannerTitleColorClass(banner.title_color)}`
                      : BANNER_TITLE_CLASS,
                  )}
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p
                  className={`
                  ${
                    isVoyagesLayout
                      ? `${V_BANNER_TEXT_CLASSES}
                      ${V_BANNER_P_CLASS}
                      ${getBannerTitleColorClass(banner.title_color)}`
                      : BANNER_TITLE_CLASS
                  }
                  `}
                >
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default SubMenuItems;
